import { companyDataReducer } from "@/reducers/company-data-slice";
import { queueReducer } from "@/reducers/queue-slice";
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import * as Sentry from "@sentry/react";

const persistConfig = {
    key: "aruza",
    storage,
};

const rootReducer = combineReducers({
    queue: queueReducer,
    companyData: companyDataReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    enhancers: (getDefaultEnhancers) =>
        import.meta.env.MODE === "production"
            ? getDefaultEnhancers().concat(Sentry.createReduxEnhancer())
            : getDefaultEnhancers(),
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
